import React from 'react';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// Normalize various input shapes into something renderable by React
const normalizeValue = (input) => {
  if (input === null || input === undefined) return '';

  if (React.isValidElement(input)) return input;

  const typeOfInput = typeof input;
  if (typeOfInput === 'string') return input;
  if (typeOfInput === 'number') return String(input);
  if (typeOfInput === 'boolean') return input ? 'true' : 'false';

  if (input instanceof Date) return input.toLocaleString();

  if (Array.isArray(input)) {
    const nodes = [];
    input.forEach((item, index) => {
      if (index > 0) nodes.push(', ');
      nodes.push(normalizeValue(item));
    });
    return nodes;
  }

  if (typeOfInput === 'object') {
    // Prefer common display keys if present
    if (Object.prototype.hasOwnProperty.call(input, 'label'))
      return normalizeValue(input.label);
    if (Object.prototype.hasOwnProperty.call(input, 'value'))
      return normalizeValue(input.value);
    if (Object.prototype.hasOwnProperty.call(input, 'name'))
      return normalizeValue(input.name);
    try {
      return JSON.stringify(input);
    } catch (err) {
      return String(input);
    }
  }

  return String(input);
};

const Text = ({
  value,
  variant = 'p',
  onClick,
  sx = {},
  fontSize,
  color,
  ...props
}) => {
  const fontSizeMultiplier = useSelector(
    (state) => state.core.user?.fontSizeMultiplier || 1
  );
  // Determine the effective font size
  let effectiveFontSize = fontSize;
  if (fontSize) {
    // If fontSize is a string with 'px', extract the number
    if (typeof fontSize === 'string' && fontSize.endsWith('px')) {
      const num = parseFloat(fontSize);
      if (!isNaN(num)) effectiveFontSize = num * fontSizeMultiplier + 'px';
    } else if (typeof fontSize === 'number') {
      effectiveFontSize = fontSize * fontSizeMultiplier;
    } else {
      effectiveFontSize = fontSize;
    }
  }

  const displayValue = normalizeValue(value);

  return (
    <div>
      <Typography
        variant={variant}
        {...props}
        color={color}
        onClick={onClick}
        sx={{
          ...sx,
          lineHeight: 1.2,
          cursor: onClick ? 'pointer' : 'default',
          ...(effectiveFontSize ? { fontSize: effectiveFontSize } : {}),

        }}
      >
        {displayValue}
      </Typography>
    </div>
  );
};

export default Text;
